import Vue from 'vue'
import Vuex from 'vuex'
import diagnosis from '@/views/diagnosis/store/diagnosis'
Vue.use(Vuex)
import commonList from './commonList'
import menu from './menu'
import activityApproval from './activityApproval'
import activityPublic from './activityPublic'
import activityReview from './activityReview'
import activityInspect from './activityInspect'
import activityDeclaration from './activityDeclaration'
import activityInfomation from './activityInfomation'
import myInfomation from './myInfomation'
import messageCenter from './messageCenter'
import creditScore from './creditScore'
import approvalSetting from './approvalSetting'
import websocket from './websocket'
import outNotification from './outNotification'
import DailyLowPrice from './DailyLowPrice'
import serviceReport from './serviceReport'
import noticeReview from './noticeReview'
import complaintSummary from './complaintSummary'
import monitorPlan from './monitorPlan'
import addLink from './addLink'
import linkSummary from './linkSummary'
import productPandect from './productPandect'
import priceChecks from './priceChecks'
import activityFlow from './activityFlow'

// 单独抽离判断逻辑，代码更清晰，也方便后续复用
const getGlobalVariables = () => {
  let bmcid = ''
  try {
    // 容错：localStorage可能无userData，或存储的不是合法JSON，所以包try/catch
    const userDataStr = localStorage.getItem('userData')
    if (userDataStr) {
      const userData = JSON.parse(userDataStr)
      // 兼容bmcid是数字/字符串的情况，统一转字符串判断
      bmcid = String(userData.bmcid || '')
    }
  } catch (e) {
    console.warn('解析localStorage的userData失败：', e)
    bmcid = ''
  }
  // 判断bmcid是否为4581，赋值两个全局变量
  const is4581 = bmcid === '4581'
  return {
    // globalLowPrice: is4581 ? 'ADI违规' : '低价',
    globalLowPrice: is4581 ? '低价' : '低价',
    globalHandPrice: is4581 ? 'ADI违规' : '到手低',
    globalPrice: is4581 ? '指数' : '价格',
    globalAbdi: is4581 ? 'ADI' : '到手价',
  }

  // {{ $store.state.globalLowPrice }}
}

// 执行方法获取初始值
const { globalLowPrice, globalHandPrice, globalPrice, globalAbdi } = getGlobalVariables()

export default new Vuex.Store({
  // 根state，定义全局变量globalVariable
  state: {
    globalLowPrice,
    globalHandPrice,
    globalPrice,
    globalAbdi
  },
  modules: {
    commonList,
    menu,
    activityApproval,
    activityPublic,
    activityReview,
    activityInspect,
    activityDeclaration,
    activityInfomation,
    myInfomation,
    creditScore,
    messageCenter,
    approvalSetting,
    outNotification,
    websocket,
    DailyLowPrice,
    serviceReport,
    noticeReview,
    complaintSummary,
    monitorPlan,
    addLink,
    linkSummary,
    productPandect,
    priceChecks,
    activityFlow,
    diagnosis
  }
})
